import React, { FC } from 'react';
import { GestureResponderEvent, View } from 'react-native';
import { TFunction } from 'i18next';

import { alertsTestIDs } from '@constants';

import { countdownSecs } from './constants';
import { styles } from './styles';

import { TWCButton } from '../../../focusable/TWCButton/TWCButton';
import { TWCText } from '../../../primitives/TWCText/TWCText';

export const OptInContent: FC<OptInContentProps> = ({
  t,
  onPress,
  startCountDown,
  onDidFinishCountDown,
  gotItHandle,
}) => (
  <View style={styles.content}>
    <TWCText
      importantForAccessibility={'no'}
      style={styles.optInTitleText}
      testID={alertsTestIDs.liveANF.optInTitle}
      variant={'regularText36'}
    >
      {t('dismissedTitleText')}
    </TWCText>
    <TWCButton
      accessibilityHint={t('gotItButtonAccessibilityHint')}
      accessibilityLabel={t('gotItButtonAccessibilityLabel', {
        seconds: countdownSecs,
      })}
      countDownTitle={t('gotItButtonText')}
      countdownSecs={countdownSecs}
      nextFocusDown={gotItHandle}
      nextFocusLeft={gotItHandle}
      nextFocusRight={gotItHandle}
      nextFocusUp={gotItHandle}
      testID={alertsTestIDs.liveANF.gotItButton}
      title={t('gotItButtonText')}
      onDidFinishCountDown={onDidFinishCountDown}
      onPress={onPress}
      onRenderCountDown={startCountDown}
    />
  </View>
);

type OptInContentProps = {
  t: TFunction;
  onPress?: (event: GestureResponderEvent) => void;
  startCountDown?: boolean;
  onDidFinishCountDown?: () => void;
  gotItHandle?: number | null;
};
